var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var addIconSVG = function (iconSvg, className, style) {
    if (!iconSvg) {
        return {
            className: className,
            style: style,
        };
    }
    return {
        className: "".concat(className || "", " fr-icon-custom").trim(),
        style: __assign(__assign({}, style), { "--icon-svg-url": "url(".concat(iconSvg, ")") }),
    };
};
